export const IS_SOCKET_OPEN_SUCCESS = 'IS_SOCKET_OPEN_SUCCESS'
export const SOCKET_ASSET_RISKS_SUCCESS = 'SOCKET_ASSET_RISKS_SUCCESS'